const LOCIZE_DATA = {
  lowQuantity: {
    key: 'PDP__OPTION_LABEL_LOW_QUANTITY',
    text: '%s Left',
  },
  soldOutNotifyMe: {
    key: 'PDP__OPTION_LABEL_NOTIFY_ME',
    text: 'Sold Out - Notify Me',
  },
  soldOutWaitlisted: {
    key: 'PDP__OPTION_LABEL_WAITLISTED',
    text: 'Sold Out - Waitlisted',
  },
  comingSoonNotifyMe: {
    key: 'PDP__COMING_SOON_NOTIFY_ME',
    text: 'Coming Soon - Notify Me',
  },
  comingSoonWaitlisted: {
    key: 'PDP__COMING_SOON_WAITLISTED',
    text: 'Coming Soon - Waitlisted',
  },
}

export default LOCIZE_DATA
